export default "__VITE_ASSET__D9XiE3fl__"